import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import {
  EntityName,
  EventType,
  SectionName,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { JumpPageSectionProps } from '../jump-page-body';

const content = [
  {
    heading: 'Tell us what you’re looking for',
    subHeading:
      'To help you find smart options, we need to ask a few basic questions. We won’t ask you to sign up for an account or send marketing emails.',
    imgSrc:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/how-it-works-2.svg',
  },
  {
    heading: 'We’ll crunch the numbers',
    subHeading:
      'Our proprietary system analyzes credit cards across a wide variety of providers, allowing us to find smart picks for your situation.',
    imgSrc:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/how-it-works-3.svg',
  },
  {
    heading: 'Compare recommendations',
    subHeading:
      'We’ll help you learn more about your personalized recommendations, and you can apply for cards immediately.',
    imgSrc:
      'https://www.nerdwallet.com/cdn/performance-marketing-client/how-it-works-1.svg',
  },
];
export const HowItWorks: React.FC<JumpPageSectionProps> = ({
  analytics: { navigationId },
}) => {
  const theme = useTheme();
  const { ref } = useImpressionEvent({
    navigationId,
    eventType: EventType.ElementImpression,
    payload: {
      entity_name: EntityName.JumpHowItWorks,
      section_name: SectionName.JumpHowItWorks,
      section_position: 2,
    },
  });
  return (
    <Box
      ref={ref}
      bgcolor="green.lightest"
      padding={5}
      sx={{ [theme.breakpoints.down('md')]: { paddingX: 3 } }}
    >
      <Box
        maxWidth="80rem"
        display="flex"
        justifyContent="space-around"
        alignItems="center"
        margin="0 auto"
        flexWrap="wrap"
        sx={{ [theme.breakpoints.up('md')]: { flexWrap: 'nowrap' } }}
      >
        {content.map((tile, idx) => (
          <Box
            paddingY={2}
            paddingX={3}
            display="flex"
            flexDirection="column"
            alignItems="center"
            marginBottom={0}
            width="33.3%"
            sx={{
              [theme.breakpoints.down('md')]: {
                paddingY: 4,
                paddingX: 2,
                marginBottom: 3,
                width: '100%',
              },
            }}
            key={tile.heading}
          >
            <Box marginBottom={3}>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src={tile.imgSrc} alt="" width={243} height={224} />
            </Box>
            <Box padding={2}>
              <Typography variant="textBold" color={theme.palette.blue.dark}>
                {idx + 1}
              </Typography>
              <Box marginBottom={1}>
                <Typography variant="textBold">{tile.heading}</Typography>
              </Box>
              <Typography variant="textSmall" color="neutral.dark">
                {tile.subHeading}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
